import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SideBarCart from "./SideBarCart";
import { CurrencySymbol } from "../../utils/Constants";
import useSubTotalPrice from "../../hooks/useSubTotalPrice";
import NewSideBarCart from "./NewSideBarCart";

const SideBarFloatingBtnComponent = ({ setShowLoginOtpModalComponent }) => {
  // const cartItems = useSelector((state) => state.cartItems);
  const { decimalPoints, cartItems } = useSelector((state) => state);
  const [ShowHideSideBarCartComponent, setShowHideSideBarCartComponent] =
    useState(false);

  // Cart Icon Qty counter state and their useEffect for change the state.
  const [counter, setCounter] = useState(0);
  useEffect(() => {
    const qty = cartItems.reduce((acc, cartItem) => acc + cartItem.quantity, 0);
    setCounter(qty);
  }, [cartItems]);

  // Hide or show the sidebar cart menu func.
  const showSideBarCartEventHandler = (type) => {
    setShowHideSideBarCartComponent(type === "open");
  };
  // const MemoizedSideBarCart = React.memo(SideBarCart);

  const subTotal = useSubTotalPrice();

  return (
    <>
      <span
        className="span cd-cart-trigger"
        onClick={() => showSideBarCartEventHandler("open")}
      >
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 383.1 343.1"
          style={{
            enableBackground: "new 0 0 383.1 343.1",
            width: "20px",
            fill: "var(--white)",
          }}
          xmlSpace="preserve"
        >
          <style>{".st0{fill:#272626"}</style>
          <path d="M0 8.6C2.7 2.1 7.6-.2 14.5 0c12.5.3 25 .1 37.4.1 15.2.1 24.8 7.5 28.8 22.2 3.9 14.6 7.9 29.1 11.7 43.8.7 2.7 1.7 3.6 4.5 3.6 54.9.1 109.8.4 164.7.6 32.7.1 65.4.3 98 .5 16 .1 26.4 12.7 22.9 28.3-8.9 39.4-18 78.8-27.2 118.2-3.1 13-13.8 21.1-27.3 21.4-4.7.1-9.5 0-14.2 0-66.4 0-132.7-.1-199.1-.1-1.7 0-3.5 0-5.2.2-6.5.7-11.1 5.9-11.1 12.5s4.6 11.7 11.2 12.4c1.7.2 3.5.1 5.2.1h219.3c8.9 0 14.2 5.1 13.3 12.8-.5 4.4-3.2 7.1-7 9.1 7.4 20.4 3.8 37.8-14.4 50.5-13.2 9.2-31.3 8.4-44.2-1.1-14.8-10.9-19-26-13-48.5h-69.9c7 20 3.2 37.2-14.6 49.4-13.9 9.5-29.1 9.4-42.9 0-17.7-12.1-21.4-29.3-14.5-49.7-5.4 0-10.4.1-15.5 0-18.4-.3-32.5-12.4-35.3-30.1-3-19.1 11.1-37.6 30.3-39.8.9-.1 1.7-.2 2.8-.4-.3-1.5-.5-2.8-.9-4.1C92 150.7 75.5 89.5 59 28.3c-1.3-5-2.2-5.6-7.2-5.6-12.5 0-25-.2-37.4.1-6.9.1-11.9-2.3-14.4-8.9V8.6zm99.5 83.7c4.5 16.7 8.8 32.6 13 48.7.6 2.2 1.8 2.5 3.8 2.5 12.5-.1 24.9 0 37.4 0 .9 0 1.9-.2 3-.4-.2-1.8-.2-3.2-.4-4.7-1.9-14.2-3.9-28.4-5.7-42.6-.3-2.6-1.2-3.3-3.7-3.3-10 .1-19.9-.1-29.9-.1-5.7-.1-11.4-.1-17.5-.1zm145.6.7v50.1c.6.2.9.3 1.3.3 13 0 25.9 0 38.9.1 2.2 0 2.7-1.1 2.9-2.9 1.4-11.3 3-22.5 4.4-33.8.6-4.5 1.1-9 1.7-13.8h-49.2zm-72.3-.3c2.3 17.1 4.5 33.8 6.7 50.5H222V92.7h-49.2zm188.1.4h-41.7c-2.4 0-2.4 1.6-2.6 3.2-1.6 12.5-3.3 25-5 37.5-.4 3.1-.7 6.2-1 9.6 12.6 0 24.6 0 36.5-.1.9 0 2.3-1.3 2.6-2.2 3.7-15.7 7.4-31.5 11.2-48zm-241.6 72.8c4.3 15.9 8.3 31.1 12.7 46.3.5 1.6 3 3.6 4.6 3.6 9.8.3 19.6.2 29.5.2 0-.9.2-1.5.1-2.1-2-15.3-4-30.7-6.1-46-.1-.8-1.5-2-2.3-2h-38.5zM245 216.2c10.6 0 20.8.1 31-.1.8 0 2.2-1.7 2.3-2.8 1.3-8.9 2.5-17.8 3.7-26.7.9-6.8 1.7-13.5 2.6-20.5H245v50.1zm-62.4-50.1c2.1 16.2 4.2 31.9 6.2 47.6.3 2.1 1.2 2.6 3.2 2.6 8.5-.1 16.9 0 25.4 0h4.7v-50.1c-13.2-.1-26.2-.1-39.5-.1zm118.2 50.1h25.7c4.7 0 6.3-1.4 7.4-6.2 1.7-7.3 3.4-14.6 5.1-21.8 1.7-7.2 3.3-14.5 5-22.1h-36.6c-2.2 16.6-4.4 33.1-6.6 50.1zM162.8 320c9.3-.1 16.9-7.7 16.7-17-.1-9.1-7.7-16.6-16.8-16.7-9.2-.1-16.8 7.6-16.8 17s7.5 16.8 16.9 16.7zm141.8 0c9.4 0 16.9-7.4 16.9-16.8 0-9.3-7.7-17-16.9-16.9-9.1.1-16.6 7.5-16.7 16.7-.2 9.4 7.3 17 16.7 17z" />
          <path
            className="st0"
            d="M99.5 92.3H117c10 0 19.9.2 29.9.1 2.5 0 3.3.7 3.7 3.3 1.8 14.2 3.8 28.4 5.7 42.6.2 1.5.3 2.9.4 4.7-1.2.1-2.1.4-3 .4h-37.4c-2 0-3.2-.3-3.8-2.5-4.2-16-8.5-32-13-48.6zM245.1 93h49.1c-.6 4.8-1.1 9.3-1.7 13.8-1.5 11.3-3 22.5-4.4 33.8-.2 1.8-.7 2.9-2.9 2.9-13-.1-25.9-.1-38.9-.1-.3 0-.7-.2-1.3-.3.1-16.7.1-33.3.1-50.1zM172.8 92.7h49.3v50.5h-42.5c-2.3-16.7-4.5-33.4-6.8-50.5zM360.9 93.1c-3.8 16.5-7.4 32.2-11.2 48-.2.9-1.7 2.2-2.6 2.2-12 .1-23.9.1-36.5.1.4-3.4.6-6.5 1-9.6 1.6-12.5 3.3-25 5-37.5.2-1.7.1-3.2 2.6-3.2h41.7zM119.3 165.9c13.4 0 25.9 0 38.5.1.8 0 2.2 1.2 2.3 2 2.1 15.3 4.1 30.6 6.1 46 .1.6 0 1.2-.1 2.1-9.9 0-19.7.2-29.5-.2-1.6-.1-4.2-2.1-4.6-3.6-4.4-15.2-8.4-30.5-12.7-46.4zM245 216.2v-50h39.6c-.9 7-1.7 13.7-2.6 20.5-1.2 8.9-2.3 17.8-3.7 26.7-.2 1.1-1.5 2.7-2.3 2.8-10.1.1-20.3 0-31 0zM182.6 166.1h39.5v50.1h-4.7c-8.5 0-16.9-.1-25.4 0-2 0-2.9-.5-3.2-2.6-2-15.6-4.1-31.3-6.2-47.5zM300.8 216.2c2.2-17 4.4-33.5 6.6-50.1H344c-1.7 7.5-3.3 14.8-5 22.1-1.7 7.3-3.4 14.6-5.1 21.8-1.1 4.8-2.7 6.1-7.4 6.2h-25.7zM162.8 320c-9.4.1-16.9-7.3-16.9-16.8 0-9.4 7.6-17 16.8-17 9.1.1 16.7 7.6 16.8 16.7.2 9.4-7.4 17.1-16.7 17.1zM304.6 320c-9.4 0-16.8-7.6-16.7-17 .1-9.2 7.6-16.7 16.7-16.7 9.2-.1 16.9 7.6 16.9 16.9 0 9.4-7.5 16.9-16.9 16.8z"
          />
        </svg>
        <div>
          {counter === 0 ? (
            <span className="cart-counter p-2">My Cart</span>
          ) : (
            <>
              <span className="cart-counter">{counter} Items</span>
              <span className="cart-counter">
                {CurrencySymbol}
                {parseFloat(subTotal).toFixed(2)}
              </span>
            </>
          )}
        </div>
      </span>

      {ShowHideSideBarCartComponent && (
        <div
          id="cd-shadow-layer"
          className={"is-visible"}
          onClick={() => showSideBarCartEventHandler("close")}
        ></div>
      )}
      {ShowHideSideBarCartComponent && (
        // <SideBarCart
        <NewSideBarCart
          counter={counter}
          isVisible={ShowHideSideBarCartComponent}
          setShowHideSideBarCartComponent={setShowHideSideBarCartComponent}
          ShowHideSideBarCartComponentEventHandler={showSideBarCartEventHandler}
          setShowLoginOtpModalComponent={setShowLoginOtpModalComponent}
        />
      )}
    </>
  );
};

export default SideBarFloatingBtnComponent;
